import React from 'react';
import styled from '@emotion/styled';
import { DCard } from './detailStyles';
import { ChevronLabel } from '@/components/common/elements/IconLabel';

/*
 * 제목 카드 — 분야·대상 칩 → 제목(모바일 18px / PC 24px, 1.35 굵게) → 강사 아바타 32px + 이름 14px("강사 정보 ›").
 */

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Chip = styled.span<{ neutral?: boolean }>`
  display: inline-block;
  height: 24px;
  line-height: 24px;
  padding: 0 9px;
  border-radius: 12px;
  font-size: 12px;
  background: ${({ neutral }) => (neutral ? '#f3f4f6' : '#eef2ff')};
  color: ${({ neutral }) => (neutral ? '#6b7280' : '#3b5bdb')};
`;

const Title = styled.h1`
  margin: 8px 0;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 800;
  color: #111827;
  word-break: keep-all;
  overflow-wrap: anywhere;

  @media (min-width: 769px) {
    font-size: 24px;
  }
`;

const InstructorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #374151;
  min-width: 0;
`;

const Avatar = styled.span`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4e8e5;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const InstructorLink = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: 14px;
  color: #9ca3af;
  cursor: pointer;
  white-space: nowrap;
`;

interface DetailTitleCardProps {
  title: string;
  chips: string[];
  levelChip?: string;
  instructorName: string;
  instructorImageUrl?: string;
  /** 커리어 강사 프로필이 있으면 "강사 정보 ›" */
  onInstructorClick?: () => void;
}

const DetailTitleCard: React.FC<DetailTitleCardProps> = ({
  title,
  chips,
  levelChip,
  instructorName,
  instructorImageUrl,
  onInstructorClick,
}) => (
  <DCard>
    {(chips.length > 0 || levelChip) && (
      <ChipRow>
        {chips.map((chip: string) => (
          <Chip key={chip}>{chip}</Chip>
        ))}
        {levelChip && <Chip neutral>{levelChip}</Chip>}
      </ChipRow>
    )}
    <Title>{title}</Title>
    <InstructorRow>
      <Avatar aria-hidden="true">{instructorImageUrl && <img src={instructorImageUrl} alt="" />}</Avatar>
      <span>{instructorName}</span>
      {onInstructorClick && (
        <InstructorLink type="button" onClick={onInstructorClick}>
          <ChevronLabel>· 강사 정보</ChevronLabel>
        </InstructorLink>
      )}
    </InstructorRow>
  </DCard>
);

export default DetailTitleCard;
